export const GET_B2B_USERS = "get_b2b_users";
export const UPDATE_B2B_USER = "update_b2b_user";